import { extendBfldrCacheTime } from "../../../../wpl/image/src/image";

import { ImageProps } from "./image-props";

export const AssigneeJane24Image = (props: ImageProps) => {
    const src = extendBfldrCacheTime(
        "https://dam-cdn.atl.orangelogic.com/AssetLink/6smlwl4eifdmx52le043b047ywb2js6v.svg"
    );
    return (
        // eslint-disable-next-line no-restricted-syntax
        <img
            height={24}
            width={24}
            alt={props.alt}
            src={src}
            data-testid={props["data-testid"]}
            className={props.className}
        />
    );
};
